import moment from "moment";
import * as XLSX from "xlsx";

const formatDayHeader = (day) => moment(day, "YYYY-MM-DD").format("DD MMM YYYY");

const formatAvailabilityCell = (stats) =>
  `Available: ${stats.available}, Total: ${stats.total}, Sold: ${stats.sold}`;

export const buildHotelAvailabilityExport = (hotels = [], days = []) => {
  const headers = ["Hotel", ...days.map(formatDayHeader)];
  const rows = hotels.map((hotel) => [
    hotel.name || "Unnamed Hotel",
    ...hotel.daily.map(formatAvailabilityCell),
  ]);

  return { headers, rows, sheetName: "Hotels" };
};

export const buildRoomPlanAvailabilityExport = (roomPlans = [], days = []) => {
  const headers = ["Room", "Rate Plan", ...days.map(formatDayHeader)];
  const rows = roomPlans.map((roomPlan) => [
    roomPlan.roomName,
    roomPlan.planName,
    ...roomPlan.daily.map(formatAvailabilityCell),
  ]);

  return { headers, rows, sheetName: "Room Plans" };
};

export const downloadAvailabilityXlsx = ({ headers, rows, sheetName, filename }) => {
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};

export const getAvailabilityExportPayload = ({
  viewMode,
  hotels,
  roomPlans,
  days,
}) => {
  if (viewMode === "roomPlans") {
    return buildRoomPlanAvailabilityExport(roomPlans, days);
  }

  return buildHotelAvailabilityExport(hotels, days);
};

export const hasAvailabilityExportData = ({
  viewMode,
  hotels,
  roomPlans,
}) => {
  if (viewMode === "roomPlans") return roomPlans.length > 0;
  return hotels.length > 0;
};
